import { Button, Flex } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";

export type RerunDocumentProcessBarProps = {
  onRerun: () => void;
  disabled?: boolean;
};

export const RerunDocumentProcessBar = ({
  onRerun,
  disabled,
}: RerunDocumentProcessBarProps) => {
  return (
    <Flex justifyContent="flex-end" alignItems="center" className={styles.bar}>
      <Button
        variant="link"
        displayAsLink
        isInline
        icon="arrows-rotate"
        disabled={disabled}
        onClick={onRerun}
        data-testid="ddq-rerun-document-process"
      >
        Re-run document process
      </Button>
    </Flex>
  );
};
